<template>
  <div class="text-image" :class="props.type">
    <div class="row-1">
      <div
        class="text-image__container"
        :class="{
          'invert-order': block.invertiOrdine,
          'p-top-6 p-bot-8': props.type === 'custom',
          'm-bot-8 m-top-11': props.type !== 'custom',
        }"
        :style="block.coloreSfondo ? { '--bg-color': block.coloreSfondo } : {}"
      >
        <div class="text-image__image">
          <div v-if="block.portrait.length">
            <WidgetPicture
              :image="{
                portrait: block.portrait?.[0],
              }"
              :alt="block.portrait?.[0]?.title"
            />
          </div>
        </div>
        <div class="text-image__text">
          <div class="text-image__content">
            <div v-if="block.sectionTitle">
              <div
                :class="
                  props.type === 'custom'
                    ? 'title-big4 is-medium-bold'
                    : props.type === 'custom2'
                      ? 'title-big4 is-medium-bold'
                      : 'title-large2'
                "
                :style="block.coloreTitolo ? { color: block.coloreTitolo } : {}"
                v-html="block.sectionTitle"
              />
            </div>
            <div v-if="block.text">
              <div
                :class="
                  props.type === 'custom'
                    ? 'title-base'
                    : props.type === 'custom2'
                      ? 'title-base'
                      : 'text-medium'
                "
                v-html="block.text"
              />
            </div>
          </div>
          <div v-if="block.linkDefault">
            <NuxtLink :to="localePath(block.linkDefault)">
              <div
                class="text-medium5 default-icon-btn is-medium-bold is-purple text-image__cta"
              >
                <span v-html="block.label" />
                <ArrowIcon alt="Arrow icon" class="icon-arrow" />
              </div>
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArrowIcon from '@/assets/img/ico/arrow-mobile.svg'

const props = defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: '',
  },
})
</script>

<script>
export default {
  name: 'TextImage',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
